const a = "avatar", t = "avatar__fallback", _ = "avatar__icon", c = {
  avatar: a,
  avatar__fallback: t,
  avatar__icon: _
};
export {
  a as avatar,
  t as avatar__fallback,
  _ as avatar__icon,
  c as default
};
